import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge the DESIGN.md radius tokens so `rounded-ds-*` overrides
// a base `rounded-md` instead of both classes surviving. Import `twMerge` from
// here, never from 'tailwind-merge' directly.
export const twMerge = extendTailwindMerge({
  extend: {
    theme: { borderRadius: ['ds-sm', 'ds-md', 'ds-lg', 'ds-full'] },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
